import styled from 'styled-components'

const Footer = styled.div`
  border-bottom: 0;
  pointer-events: none;
  text-transform: uppercase;
`

export default Footer
